import { Link } from "react-router-dom";

export default function GreatSection({ img, extra }) {
  return (
    <div
      className={`greatsection-wrapper section ${
        img && "greatsection-wrapper-office"
      }`}
    >
      <div className="greatsection container">
        <div className="greatsection-content flex">
          <h2 className="clr-white fs-700 medium">
            What our students benefit from{" "}
            <span className="bold">learning with us</span>?
          </h2>
          {extra ? (
            <>
              <p className="clr-gray">
                At a time when technology was changing the world at a rapid
                pace, Innovation Academy was born – an academy that was not just
                a school, but a creative ecosystem for young people who dreamed
                of becoming creators and not just consumers of technology.
              </p>
              <p className="clr-gray">
                <b className="clr-blue">Real-World Skills:</b> From coding and
                entrepreneurship, students build practical skills that prepare
                them for the digital economy.
              </p>
              <p className="clr-gray">
                <b className="clr-blue">Confidence & Creativity:</b> Our
                learning model encourages experimentation, problem-solving, and
                creative thinking.
              </p>
              <p className="clr-gray">
                <b className="clr-blue">Global Opportunities:</b> Through our
                international partnerships and projects, students get exposure
                to global tech trends and career pathways.
              </p>
              <p className="clr-gray">
                <b className="clr-blue">Mentorship & Community:</b> Students
                learn in a supportive environment, guided by expert mentors and
                surrounded by like-minded peers.
              </p>
              <p className="clr-gray">
                <b className="clr-blue">Portfolio & Recognition:</b> By the time
                they graduate, students have built projects they can showcase
                and are recognized for their achievements locally and
                internationally.
              </p>
              <p className="clr-gray">
                Innovation Academy is more than just a place to learn — it's
                where future innovators are born.
              </p>
            </>
          ) : (
            <p className="clr-gray-text">
              Our students gain practical skills in coding, technology,
              communication, and teamwork, preparing them for success in a
              fast-paced world.
            </p>
          )}
          <a
            href="/about/#aboutScrollTo"
            className="greenblue-button fs-200 clr-dark transition pointer"
          >
            Learn more
          </a>
        </div>
      </div>
    </div>
  );
}
